module.exports = __webpack_public_path__ + "static/media/3BottomIcons.7be3605d.png";